type PosthogServerCapturePayload = {
  distinctId: string
  event: string
  properties: Record<string, unknown>
  groups?: Record<string, string>
}

const DEFAULT_POSTHOG_HOST = 'https://us.i.posthog.com'
const POSTHOG_BATCH_SIZE = 100

const getPosthogBatchUrl = () => {
  const host = process.env.NEXT_PUBLIC_POSTHOG_HOST || DEFAULT_POSTHOG_HOST
  return `${host.replace(/\/+$/, '')}/batch/`
}

export const safeCapturePosthogServerEvents = async (
  payloads: PosthogServerCapturePayload[]
) => {
  const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY

  if (!posthogKey || payloads.length === 0) {
    return
  }

  const payloadBatches: PosthogServerCapturePayload[][] = []
  for (let index = 0; index < payloads.length; index += POSTHOG_BATCH_SIZE) {
    payloadBatches.push(payloads.slice(index, index + POSTHOG_BATCH_SIZE))
  }

  const results = await Promise.allSettled(
    payloadBatches.map(async payloadBatch => {
      const response = await fetch(getPosthogBatchUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          api_key: posthogKey,
          batch: payloadBatch.map(payload => ({
            distinct_id: payload.distinctId,
            event: payload.event,
            properties: {
              ...payload.properties,
              ...(payload.groups ? { $groups: payload.groups } : {})
            },
            timestamp: new Date().toISOString()
          })),
          sent_at: new Date().toISOString()
        })
      })

      try {
        if (!response.ok) {
          throw new Error(
            `PostHog capture failed with ${response.status} ${response.statusText}`.trim()
          )
        }
      } finally {
        await response.body?.cancel()
      }
    })
  )

  for (const result of results) {
    if (result.status === 'rejected') {
      console.warn('[PostHog] server capture failed', result.reason)
    }
  }
}

export const safeCapturePosthogServerEvent = (
  payload: PosthogServerCapturePayload
) => safeCapturePosthogServerEvents([payload])
